export const environment = {
  production: true,
  configSettings: `config.json`,
};
